import { render } from "./PoemFooter.vue?vue&type=template&id=291958d8"
import script from "./PoemFooter.vue?vue&type=script&lang=js"
export * from "./PoemFooter.vue?vue&type=script&lang=js"

import "./PoemFooter.vue?vue&type=style&index=0&id=291958d8&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__